import axios from "axios";

export default axios.create({
  baseURL: window.location.href,
  headers: {
    "Content-type": "application/json"
  }
});